import { ServerResponse } from "@core/server/domain/server.interface";
import {
  addGrowingSeasonApi,
  deleteFieldsApi,
  getFarmersFieldsApi,
  getFarmsApi,
  getStaticCitiesApi,
  getStaticProvincesApi,
  registerFarmApi,
  updateFieldApi,
} from "@core/server/utils/apis";
import { AddGrowingSeasonArguments } from "@/features/growing-season/data/datasources/growing-season-datasources";
import { Season } from "@/features/growing-season/domain/growing-season.interface";
import {
  CitiesData,
  Farm,
  Farms,
  ProvincesList,
} from "@/features/farm/domain/farm.interface";

export async function getFarms() {
  const response: Promise<ServerResponse<Farms> | undefined> =
    await getFarmsApi();
  return (await response)?.data.farms;
}

export async function getFarmersFields() {
  const response: Promise<ServerResponse<any> | undefined> =
    await getFarmersFieldsApi();
  return (await response)?.data.farmersFields;
}

export async function getStaticIrrigationSources() {
  const response: Promise<ServerResponse<any> | undefined> =
    await getFarmersFieldsApi();
  return (await response)?.data.farmersFields["IRRIGATION_SOURCES"];
}

export async function getStaticOwnershipType() {
  const response: Promise<ServerResponse<any> | undefined> =
    await getFarmersFieldsApi();
  return (await response)?.data.farmersFields["OWNERSHIP_TYPE"];
}

export async function getStaticCities() {
  const response: Promise<ServerResponse<CitiesData> | undefined> =
    await getStaticCitiesApi();
  return (await response)?.data?.cities;
}

export async function getStaticProvinces() {
  const response: Promise<ServerResponse<ProvincesList> | undefined> =
    await getStaticProvincesApi();
  return (await response)?.data?.provinces;
}

export async function addGrowingSeason({
  season,
  farmId,
}: AddGrowingSeasonArguments) {
  const response: Promise<ServerResponse<Season> | undefined> =
    await addGrowingSeasonApi({ season, farmId });
  return (await response)?.data;
}

//any
export async function registerField() {
  const response: Promise<ServerResponse<Farm> | undefined> =
    await registerFarmApi();
  return (await response)?.data;
}

//any
export async function updateField({ data }: any) {
  const response: Promise<ServerResponse<any> | undefined> =
    await updateFieldApi({ data });
  return (await response)?.data?.result;
}

export async function deleteFields(farmId: string) {
  const response: Promise<ServerResponse<string> | undefined> =
    await deleteFieldsApi(farmId);
  return (await response)?.data;
}
